import LoginWithLinkPageComponent from './LoginWithLinkPage'

export default LoginWithLinkPageComponent
// eslint-disable-next-line import/export
export * from './LoginWithLinkPage'
